const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// localStorage에서 anonymousId 가져오기 (없으면 생성)
function getAnonymousId() {
  let id = localStorage.getItem('epix_anonymous_id');
  if (!id) {
    id = 'anon_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('epix_anonymous_id', id);
  }
  return id;
}

/**
 * 명함 상호작용 기록
 * @param {string} cardId - Firestore card document ID (shortId)
 * @param {string} type - view | share_copy | qr_scan | vcard_download |
 *                        linkedin_click | remember_click | contact_phone | contact_email
 * @param {string|null} idToken - Firebase ID Token (로그인 시)
 */
export async function trackInteraction(cardId, type, idToken = null) {
  if (!cardId) return; // shortId 없으면 조용히 skip

  try {
    const headers = { 'Content-Type': 'application/json' };
    if (idToken) headers['Authorization'] = `Bearer ${idToken}`;

    await fetch(`${API_BASE}/api/interact/${cardId}/${type}`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ anonymousId: getAnonymousId() }),
    });
  } catch {
    // 트래킹 실패는 사용자 경험에 영향 없도록 무시
  }
}
